<template>
  <FlexCol class="min-h-screen w-full bg-cockpit-canvas text-cockpit-text">
    <header v-if="user" class="flex h-14 items-center justify-between border-b border-cockpit-line bg-cockpit-surface px-3 shadow-cockpit sm:px-4">
      <Flex items-center gap-3>
        <div class="flex size-8 items-center justify-center rounded border border-cockpit-green bg-cockpit-green/10 font-mono text-xs font-bold text-cockpit-green" aria-hidden="true">WC</div>
        <div class="hidden min-w-0 sm:block">
          <div class="text-[10px] font-semibold tracking-[0.2em] text-cockpit-muted">OPERATIONS CONSOLE</div>
          <span class="text-sm font-semibold tracking-wide text-cockpit-text">WORK COCKPIT</span>
        </div>
        <button
          type="button"
          class="rounded border border-cockpit-line p-2 text-cockpit-muted transition-colors hover:border-cockpit-green hover:bg-cockpit-green/10 hover:text-cockpit-green focus:outline-none focus:ring-2 focus:ring-cockpit-green"
          aria-label="Alternar menu lateral"
          @click="lateralMenu = !lateralMenu">
          <i class="fa-solid fa-bars" aria-hidden="true" />
        </button>
      </Flex>
      <div class="hidden items-center gap-2 font-mono text-[10px] tracking-[0.12em] text-cockpit-muted md:flex">
        <span class="size-2 rounded-full bg-cockpit-green" aria-hidden="true" />
        LOCAL-FIRST
      </div>
      <AppUserBar />
    </header>

    <Flex class="min-h-0 grow">
      <AppSidebar v-if="user" v-model="lateralMenu" />
      <main class="min-h-0 grow overflow-auto bg-cockpit-canvas bg-[linear-gradient(rgba(53,255,105,0.035)_1px,transparent_1px),linear-gradient(90deg,rgba(53,255,105,0.035)_1px,transparent_1px)] bg-[size:28px_28px] p-3 sm:p-5">
        <router-view />
      </main>
    </Flex>

    <footer v-if="user" class="border-t border-cockpit-line bg-cockpit-surface px-5 py-2 text-right font-mono text-[10px] tracking-[0.12em] text-cockpit-muted">
      WORK COCKPIT // LOCAL OPERATIONAL CONTEXT
    </footer>
  </FlexCol>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const lateralMenu = ref(true)
const user = computed(() => store.state.user)
</script>
